import actions from "@/lang/ja/actions"
import screens from "@/lang/ja/screens"
import terms from "@/lang/ja/terms"

export const ja = {
  actions,
  screens,
  terms,
}
